import {
  Box,
  Button,
  Modal,
  Table,
  InputField,
  Typography,
  getColor,
  ColumnDatas,
} from "fds";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAdminWorkgroupStore from "../../redux/dispatcher/useAdminWorkgroupStore";
import { DocInfo } from "../../types/files";
import utilsDocs from "../../shared/utils/docs";
import utilsCommon from "../../shared/utils/common";
import { FilterData } from "../../types/adminFilter";
import AdminFilter from "../../components/AdminFilter";

export type ModalProps = {
  workgroupId: string;
  showWorkgroupFilelModal: boolean;
  onClose: any;
};
const WorkgroupFileModal: React.FC<ModalProps> = ({
  workgroupId,
  showWorkgroupFilelModal,
  onClose,
}) => {
  const { adminWorkgroupStore, getContentList, downloadContent } =
    useAdminWorkgroupStore();

  const initFilterData = {
    fileName: "",
    fileManager: "",
  } as FilterData;

  const { t } = useTranslation();

  /**** State 모음 ****/
  const [contentList, setContentList] = useState([] as DocInfo[]);
  const [filterData, setFilterData] = useState<FilterData>(initFilterData);
  const [total, setTotal] = useState(-1);
  const pageCount = 50;
  const [nextPage, setNextPage] = useState(-1);
  const [initDone, setInitDone] = useState(false);

  /**** UseEffect 모음 ****/
  useEffect(() => {
    getContentListFunc(0);
    setInitDone(true);
  }, []);

  useEffect(() => {
    initDone && getContentListFunc(0);
  }, [filterData]);

  useEffect(() => {
    if (adminWorkgroupStore.contentList.pages?.page !== undefined) {
      if (adminWorkgroupStore.contentList.pages.page === 0) {
        setContentList(adminWorkgroupStore.contentList.docs.doc);
        setTotal(adminWorkgroupStore.contentList.total);
      } else {
        setContentList(
          contentList.concat(adminWorkgroupStore.contentList.docs.doc)
        );
      }
      setNextPage(adminWorkgroupStore.contentList.pages.nextPage);
    }
  }, [adminWorkgroupStore.contentList]);

  const getContentListFunc = (page: number) => {
    if (page !== -1) {
      getContentList({
        folderCode: "",
        page: page,
        size: pageCount,
        order: "datadesc",
        search: filterData.fileName + "",
        readType: "",
        masterUserId: filterData.fileManager + "",
        tagCodes: [workgroupId],
        date: {
          start: 0,
          end: new Date().valueOf(),
        },
      });
    }
  };

  function onCloseFunc() {
    setContentList([]);
    setTotal(-1);
    setNextPage(-1);
    onClose();
  }

  function transformFileList(data: any[] | undefined) {
    const dataTransformed = [] as ColumnDatas[];
    data &&
      data?.map((item: any, index: number) => {
        const dataItemTransformed = {
          data: [
            {
              columnText: "",
            },
            {
              columnText: (
                <Box alignItems="center">
                  {utilsDocs.renderDocIcon(item.contentName, 28)}
                  <Typography
                    ellipsis
                    classes="mg ml-4"
                    maxWidth={"calc(100% - 32px)"}
                  >
                    {item.contentName}
                  </Typography>
                </Box>
              ),
            },
            {
              columnText: item.masterUser.userName,
            },
            {
              columnText: item.revisionNo,
            },
            {
              columnText: utilsCommon.renderDateFormat(item.revisionDate),
            },
            {
              columnText: (
                <Button
                  type="primary"
                  btnStyle="fill"
                  size="sm"
                  label={t("admin.workgroup.download")}
                  onClick={() => {
                    downloadContent({
                      syncId: item.syncId,
                      revisionNo: item.revisionNo,
                    });
                  }}
                />
              ),
            },
          ],
          id: item.syncId,
        };
        dataTransformed.push(dataItemTransformed);
      });
    return dataTransformed;
  }

  return (
    <Modal
      open={showWorkgroupFilelModal}
      onClose={() => {
        onCloseFunc();
      }}
      title={t("admin.workgroup.fileList")}
      width={1000}
      height={724}
      isFooter={false}
      body={
        <Box direction="column" width={"100%"}>
          <Box direction="column" classes="pd pt-4">
            <Box height={60} minHeight={60}>
              <AdminFilter
                initFilterData={initFilterData}
                filterData={filterData}
                setFilterData={setFilterData}
              />
            </Box>
            <Box height={20} minHeight={20}>
              <Typography type="subtitle2">
                {t("admin.common.label.document")}
              </Typography>
              {total > -1 && (
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_BRAND")}
                  classes={"mg ml-4"}
                >
                  {total}
                </Typography>
              )}
            </Box>
          </Box>
          <Box classes="mg mt-12" direction="column">
            <Table
              width={"100%"}
              height={"470px"}
              header={[
                {
                  headerText: "",
                  width: "24px",
                  order: "",
                  orderAction: () => {},
                },
                {
                  headerText: t("admin.workgroup.fileName"),
                  width: "calc(100% - 650px)",
                  order: "",
                  orderAction: () => {},
                },
                {
                  headerText: t("admin.workgroup.fileManager"),
                  width: "200px",
                  order: "",
                  orderAction: () => {},
                },
                {
                  headerText: t("admin.workgroup.version"),
                  width: "100px",
                  order: "",
                  orderAction: () => {},
                },
                {
                  headerText: t("admin.workgroup.versionCreated"),
                  width: "200px",
                  order: "",
                  orderAction: () => {},
                },
                {
                  headerText: "",
                  width: "100px",
                  order: "",
                  orderAction: () => {},
                },
              ]}
              data={transformFileList(contentList)}
              totalCount={contentList.length}
              endReached={() => {
                getContentListFunc(nextPage);
              }}
              columnHeight="md"
            />
          </Box>
        </Box>
      }
    />
  );
};
export default WorkgroupFileModal;
